@file:OptIn(InternalResourceApi::class)

package gsb_vyparbhagya.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gsb_vyparbhagya.composeapp.generated.resources/"

internal val Res.drawable._1: DrawableResource by lazy {
      DrawableResource("drawable:_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/1.png", -1, -1),
      ))
    }

internal val Res.drawable._10: DrawableResource by lazy {
      DrawableResource("drawable:_10", setOf(
        ResourceItem(setOf(), "${MD}drawable/10.png", -1, -1),
      ))
    }

internal val Res.drawable._11: DrawableResource by lazy {
      DrawableResource("drawable:_11", setOf(
        ResourceItem(setOf(), "${MD}drawable/11.png", -1, -1),
      ))
    }

internal val Res.drawable._12: DrawableResource by lazy {
      DrawableResource("drawable:_12", setOf(
        ResourceItem(setOf(), "${MD}drawable/12.png", -1, -1),
      ))
    }

internal val Res.drawable._13: DrawableResource by lazy {
      DrawableResource("drawable:_13", setOf(
        ResourceItem(setOf(), "${MD}drawable/13.png", -1, -1),
      ))
    }

internal val Res.drawable._14: DrawableResource by lazy {
      DrawableResource("drawable:_14", setOf(
        ResourceItem(setOf(), "${MD}drawable/14.png", -1, -1),
      ))
    }

internal val Res.drawable._15: DrawableResource by lazy {
      DrawableResource("drawable:_15", setOf(
        ResourceItem(setOf(), "${MD}drawable/15.png", -1, -1),
      ))
    }

internal val Res.drawable._16: DrawableResource by lazy {
      DrawableResource("drawable:_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/16.png", -1, -1),
      ))
    }

internal val Res.drawable._17: DrawableResource by lazy {
      DrawableResource("drawable:_17", setOf(
        ResourceItem(setOf(), "${MD}drawable/17.png", -1, -1),
      ))
    }

internal val Res.drawable._18: DrawableResource by lazy {
      DrawableResource("drawable:_18", setOf(
        ResourceItem(setOf(), "${MD}drawable/18.png", -1, -1),
      ))
    }

internal val Res.drawable._2: DrawableResource by lazy {
      DrawableResource("drawable:_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/2.png", -1, -1),
      ))
    }

internal val Res.drawable._3: DrawableResource by lazy {
      DrawableResource("drawable:_3", setOf(
        ResourceItem(setOf(), "${MD}drawable/3.png", -1, -1),
      ))
    }

internal val Res.drawable._4: DrawableResource by lazy {
      DrawableResource("drawable:_4", setOf(
        ResourceItem(setOf(), "${MD}drawable/4.png", -1, -1),
      ))
    }

internal val Res.drawable._5: DrawableResource by lazy {
      DrawableResource("drawable:_5", setOf(
        ResourceItem(setOf(), "${MD}drawable/5.png", -1, -1),
      ))
    }

internal val Res.drawable._6: DrawableResource by lazy {
      DrawableResource("drawable:_6", setOf(
        ResourceItem(setOf(), "${MD}drawable/6.png", -1, -1),
      ))
    }

internal val Res.drawable._7: DrawableResource by lazy {
      DrawableResource("drawable:_7", setOf(
        ResourceItem(setOf(), "${MD}drawable/7.png", -1, -1),
      ))
    }

internal val Res.drawable._8: DrawableResource by lazy {
      DrawableResource("drawable:_8", setOf(
        ResourceItem(setOf(), "${MD}drawable/8.png", -1, -1),
      ))
    }

internal val Res.drawable._9: DrawableResource by lazy {
      DrawableResource("drawable:_9", setOf(
        ResourceItem(setOf(), "${MD}drawable/9.png", -1, -1),
      ))
    }

internal val Res.drawable.account_circle: DrawableResource by lazy {
      DrawableResource("drawable:account_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/account_circle.xml", -1, -1),
      ))
    }

internal val Res.drawable.add: DrawableResource by lazy {
      DrawableResource("drawable:add", setOf(
        ResourceItem(setOf(), "${MD}drawable/add.png", -1, -1),
      ))
    }

internal val Res.drawable.add_icon: DrawableResource by lazy {
      DrawableResource("drawable:add_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/add_icon.xml", -1, -1),
      ))
    }

internal val Res.drawable.address: DrawableResource by lazy {
      DrawableResource("drawable:address", setOf(
        ResourceItem(setOf(), "${MD}drawable/address.png", -1, -1),
      ))
    }

internal val Res.drawable.applestore: DrawableResource by lazy {
      DrawableResource("drawable:applestore", setOf(
        ResourceItem(setOf(), "${MD}drawable/applestore.png", -1, -1),
      ))
    }

internal val Res.drawable.arrow_back: DrawableResource by lazy {
      DrawableResource("drawable:arrow_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_back.xml", -1, -1),
      ))
    }

internal val Res.drawable.arrow_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_down.xml", -1, -1),
      ))
    }

internal val Res.drawable.arrow_up: DrawableResource by lazy {
      DrawableResource("drawable:arrow_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_up.xml", -1, -1),
      ))
    }

internal val Res.drawable.call: DrawableResource by lazy {
      DrawableResource("drawable:call", setOf(
        ResourceItem(setOf(), "${MD}drawable/call.xml", -1, -1),
      ))
    }

internal val Res.drawable.category: DrawableResource by lazy {
      DrawableResource("drawable:category", setOf(
        ResourceItem(setOf(), "${MD}drawable/category.png", -1, -1),
      ))
    }

internal val Res.drawable.close: DrawableResource by lazy {
      DrawableResource("drawable:close", setOf(
        ResourceItem(setOf(), "${MD}drawable/close.xml", -1, -1),
      ))
    }

internal val Res.drawable.close_black: DrawableResource by lazy {
      DrawableResource("drawable:close_black", setOf(
        ResourceItem(setOf(), "${MD}drawable/close_black.xml", -1, -1),
      ))
    }

internal val Res.drawable.cross: DrawableResource by lazy {
      DrawableResource("drawable:cross", setOf(
        ResourceItem(setOf(), "${MD}drawable/cross.png", -1, -1),
      ))
    }

internal val Res.drawable.delete: DrawableResource by lazy {
      DrawableResource("drawable:delete", setOf(
        ResourceItem(setOf(), "${MD}drawable/delete.xml", -1, -1),
      ))
    }

internal val Res.drawable.direction: DrawableResource by lazy {
      DrawableResource("drawable:direction", setOf(
        ResourceItem(setOf(), "${MD}drawable/direction.xml", -1, -1),
      ))
    }

internal val Res.drawable.edit: DrawableResource by lazy {
      DrawableResource("drawable:edit", setOf(
        ResourceItem(setOf(), "${MD}drawable/edit.xml", -1, -1),
      ))
    }

internal val Res.drawable.facebook: DrawableResource by lazy {
      DrawableResource("drawable:facebook", setOf(
        ResourceItem(setOf(), "${MD}drawable/facebook.png", -1, -1),
      ))
    }

internal val Res.drawable.failure: DrawableResource by lazy {
      DrawableResource("drawable:failure", setOf(
        ResourceItem(setOf(), "${MD}drawable/failure.png", -1, -1),
      ))
    }

internal val Res.drawable.fav_off: DrawableResource by lazy {
      DrawableResource("drawable:fav_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/fav_off.xml", -1, -1),
      ))
    }

internal val Res.drawable.fav_on: DrawableResource by lazy {
      DrawableResource("drawable:fav_on", setOf(
        ResourceItem(setOf(), "${MD}drawable/fav_on.xml", -1, -1),
      ))
    }

internal val Res.drawable.favorites: DrawableResource by lazy {
      DrawableResource("drawable:favorites", setOf(
        ResourceItem(setOf(), "${MD}drawable/favorites.png", -1, -1),
      ))
    }

internal val Res.drawable.googlemaps: DrawableResource by lazy {
      DrawableResource("drawable:googlemaps", setOf(
        ResourceItem(setOf(), "${MD}drawable/googlemaps.png", -1, -1),
      ))
    }

internal val Res.drawable.googlestore: DrawableResource by lazy {
      DrawableResource("drawable:googlestore", setOf(
        ResourceItem(setOf(), "${MD}drawable/googlestore.png", -1, -1),
      ))
    }

internal val Res.drawable.home: DrawableResource by lazy {
      DrawableResource("drawable:home", setOf(
        ResourceItem(setOf(), "${MD}drawable/home.png", -1, -1),
      ))
    }

internal val Res.drawable.info: DrawableResource by lazy {
      DrawableResource("drawable:info", setOf(
        ResourceItem(setOf(), "${MD}drawable/info.xml", -1, -1),
      ))
    }

internal val Res.drawable.instagram: DrawableResource by lazy {
      DrawableResource("drawable:instagram", setOf(
        ResourceItem(setOf(), "${MD}drawable/instagram.png", -1, -1),
      ))
    }

internal val Res.drawable.latest: DrawableResource by lazy {
      DrawableResource("drawable:latest", setOf(
        ResourceItem(setOf(), "${MD}drawable/latest.png", -1, -1),
      ))
    }

internal val Res.drawable.left: DrawableResource by lazy {
      DrawableResource("drawable:left", setOf(
        ResourceItem(setOf(), "${MD}drawable/left.xml", -1, -1),
      ))
    }

internal val Res.drawable.linkedin: DrawableResource by lazy {
      DrawableResource("drawable:linkedin", setOf(
        ResourceItem(setOf(), "${MD}drawable/linkedin.png", -1, -1),
      ))
    }

internal val Res.drawable.linux: DrawableResource by lazy {
      DrawableResource("drawable:linux", setOf(
        ResourceItem(setOf(), "${MD}drawable/linux.png", -1, -1),
      ))
    }

internal val Res.drawable.location: DrawableResource by lazy {
      DrawableResource("drawable:location", setOf(
        ResourceItem(setOf(), "${MD}drawable/location.xml", -1, -1),
      ))
    }

internal val Res.drawable.mac: DrawableResource by lazy {
      DrawableResource("drawable:mac", setOf(
        ResourceItem(setOf(), "${MD}drawable/mac.icns", -1, -1),
      ))
    }

internal val Res.drawable.mail: DrawableResource by lazy {
      DrawableResource("drawable:mail", setOf(
        ResourceItem(setOf(), "${MD}drawable/mail.xml", -1, -1),
      ))
    }

internal val Res.drawable.menu: DrawableResource by lazy {
      DrawableResource("drawable:menu", setOf(
        ResourceItem(setOf(), "${MD}drawable/menu.xml", -1, -1),
      ))
    }

internal val Res.drawable.placeholder: DrawableResource by lazy {
      DrawableResource("drawable:placeholder", setOf(
        ResourceItem(setOf(), "${MD}drawable/placeholder.webp", -1, -1),
      ))
    }

internal val Res.drawable.right: DrawableResource by lazy {
      DrawableResource("drawable:right", setOf(
        ResourceItem(setOf(), "${MD}drawable/right.xml", -1, -1),
      ))
    }

internal val Res.drawable.rotateleft: DrawableResource by lazy {
      DrawableResource("drawable:rotateleft", setOf(
        ResourceItem(setOf(), "${MD}drawable/rotateleft.xml", -1, -1),
      ))
    }

internal val Res.drawable.rotateright: DrawableResource by lazy {
      DrawableResource("drawable:rotateright", setOf(
        ResourceItem(setOf(), "${MD}drawable/rotateright.xml", -1, -1),
      ))
    }

internal val Res.drawable.search: DrawableResource by lazy {
      DrawableResource("drawable:search", setOf(
        ResourceItem(setOf(), "${MD}drawable/search.xml", -1, -1),
      ))
    }

internal val Res.drawable.share: DrawableResource by lazy {
      DrawableResource("drawable:share", setOf(
        ResourceItem(setOf(), "${MD}drawable/share.xml", -1, -1),
      ))
    }

internal val Res.drawable.splash: DrawableResource by lazy {
      DrawableResource("drawable:splash", setOf(
        ResourceItem(setOf(), "${MD}drawable/splash.png", -1, -1),
      ))
    }

internal val Res.drawable.star: DrawableResource by lazy {
      DrawableResource("drawable:star", setOf(
        ResourceItem(setOf(), "${MD}drawable/star.xml", -1, -1),
      ))
    }

internal val Res.drawable.sucess: DrawableResource by lazy {
      DrawableResource("drawable:sucess", setOf(
        ResourceItem(setOf(), "${MD}drawable/sucess.png", -1, -1),
      ))
    }

internal val Res.drawable.thumb_up: DrawableResource by lazy {
      DrawableResource("drawable:thumb_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/thumb_up.xml", -1, -1),
      ))
    }

internal val Res.drawable.twitter: DrawableResource by lazy {
      DrawableResource("drawable:twitter", setOf(
        ResourceItem(setOf(), "${MD}drawable/twitter.png", -1, -1),
      ))
    }

internal val Res.drawable.view_full_map: DrawableResource by lazy {
      DrawableResource("drawable:view_full_map", setOf(
        ResourceItem(setOf(), "${MD}drawable/view_full_map.xml", -1, -1),
      ))
    }

internal val Res.drawable.visibility_off: DrawableResource by lazy {
      DrawableResource("drawable:visibility_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/visibility_off.xml", -1, -1),
      ))
    }

internal val Res.drawable.visibility_on: DrawableResource by lazy {
      DrawableResource("drawable:visibility_on", setOf(
        ResourceItem(setOf(), "${MD}drawable/visibility_on.xml", -1, -1),
      ))
    }

internal val Res.drawable.web: DrawableResource by lazy {
      DrawableResource("drawable:web", setOf(
        ResourceItem(setOf(), "${MD}drawable/web.png", -1, -1),
      ))
    }

internal val Res.drawable.webstore: DrawableResource by lazy {
      DrawableResource("drawable:webstore", setOf(
        ResourceItem(setOf(), "${MD}drawable/webstore.jpg", -1, -1),
      ))
    }

internal val Res.drawable.whatsapp: DrawableResource by lazy {
      DrawableResource("drawable:whatsapp", setOf(
        ResourceItem(setOf(), "${MD}drawable/whatsapp.xml", -1, -1),
      ))
    }

internal val Res.drawable.windows: DrawableResource by lazy {
      DrawableResource("drawable:windows", setOf(
        ResourceItem(setOf(), "${MD}drawable/windows.ico", -1, -1),
      ))
    }

internal val Res.drawable.youtube: DrawableResource by lazy {
      DrawableResource("drawable:youtube", setOf(
        ResourceItem(setOf(), "${MD}drawable/youtube.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("_1", Res.drawable._1)
  map.put("_10", Res.drawable._10)
  map.put("_11", Res.drawable._11)
  map.put("_12", Res.drawable._12)
  map.put("_13", Res.drawable._13)
  map.put("_14", Res.drawable._14)
  map.put("_15", Res.drawable._15)
  map.put("_16", Res.drawable._16)
  map.put("_17", Res.drawable._17)
  map.put("_18", Res.drawable._18)
  map.put("_2", Res.drawable._2)
  map.put("_3", Res.drawable._3)
  map.put("_4", Res.drawable._4)
  map.put("_5", Res.drawable._5)
  map.put("_6", Res.drawable._6)
  map.put("_7", Res.drawable._7)
  map.put("_8", Res.drawable._8)
  map.put("_9", Res.drawable._9)
  map.put("account_circle", Res.drawable.account_circle)
  map.put("add", Res.drawable.add)
  map.put("add_icon", Res.drawable.add_icon)
  map.put("address", Res.drawable.address)
  map.put("applestore", Res.drawable.applestore)
  map.put("arrow_back", Res.drawable.arrow_back)
  map.put("arrow_down", Res.drawable.arrow_down)
  map.put("arrow_up", Res.drawable.arrow_up)
  map.put("call", Res.drawable.call)
  map.put("category", Res.drawable.category)
  map.put("close", Res.drawable.close)
  map.put("close_black", Res.drawable.close_black)
  map.put("cross", Res.drawable.cross)
  map.put("delete", Res.drawable.delete)
  map.put("direction", Res.drawable.direction)
  map.put("edit", Res.drawable.edit)
  map.put("facebook", Res.drawable.facebook)
  map.put("failure", Res.drawable.failure)
  map.put("fav_off", Res.drawable.fav_off)
  map.put("fav_on", Res.drawable.fav_on)
  map.put("favorites", Res.drawable.favorites)
  map.put("googlemaps", Res.drawable.googlemaps)
  map.put("googlestore", Res.drawable.googlestore)
  map.put("home", Res.drawable.home)
  map.put("info", Res.drawable.info)
  map.put("instagram", Res.drawable.instagram)
  map.put("latest", Res.drawable.latest)
  map.put("left", Res.drawable.left)
  map.put("linkedin", Res.drawable.linkedin)
  map.put("linux", Res.drawable.linux)
  map.put("location", Res.drawable.location)
  map.put("mac", Res.drawable.mac)
  map.put("mail", Res.drawable.mail)
  map.put("menu", Res.drawable.menu)
  map.put("placeholder", Res.drawable.placeholder)
  map.put("right", Res.drawable.right)
  map.put("rotateleft", Res.drawable.rotateleft)
  map.put("rotateright", Res.drawable.rotateright)
  map.put("search", Res.drawable.search)
  map.put("share", Res.drawable.share)
  map.put("splash", Res.drawable.splash)
  map.put("star", Res.drawable.star)
  map.put("sucess", Res.drawable.sucess)
  map.put("thumb_up", Res.drawable.thumb_up)
  map.put("twitter", Res.drawable.twitter)
  map.put("view_full_map", Res.drawable.view_full_map)
  map.put("visibility_off", Res.drawable.visibility_off)
  map.put("visibility_on", Res.drawable.visibility_on)
  map.put("web", Res.drawable.web)
  map.put("webstore", Res.drawable.webstore)
  map.put("whatsapp", Res.drawable.whatsapp)
  map.put("windows", Res.drawable.windows)
  map.put("youtube", Res.drawable.youtube)
}
